import { DefineDevice, VirtualMG63, VirtualMg75, VirtualMg75Pro, VirtualMG75V2C12, VirtualNd63, VirtualNd63_Cyan, VirtualRA68_1 } from './define'

const Na87ProKeyboardMatrix = [
  [41, 0, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72],
  [53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 73, 74, 75],
  [43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 76, 77, 78],
  [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 0, 0, 0, 0],
  [225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 0, 0, 82, 0],
  [224, 227, 226, 44, 0, 0, 0, 0, 0, 0, 230, 1, 101, 228, 80, 81, 79],
]

const Nd63KeyboardMatrix = [
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [41, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 0, 0, 0],
  [43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 0, 0, 0],
  [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 0, 0, 0, 0],
  [225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 99, 0, 0],
  [224, 227, 226, 44, 0, 0, 0, 0, 0, 0, 230, 1, 80, 81, 79, 0, 0],
]

const MG75KeyboardMatrix = [
  [41, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 76, 0, 0],
  [53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 73, 0, 0],
  [43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 75, 0, 0],
  [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 0, 78, 0, 0],
  [225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 0, 82, 0, 0],
  [224, 227, 226, 44, 0, 0, 0, 0, 0, 0, 230, 1, 80, 81, 79, 0, 0],
]

//light matrix data
const lightMatrixData = [
  [0, 6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96],
  [1, 7, 13, 19, 25, 31, 37, 43, 49, 55, 61, 67, 73, 79, 85, 91, 97],
  [2, 8, 14, 20, 26, 32, 38, 44, 50, 56, 62, 68, 74, 80, 86, 92, 98],
  [3, 9, 15, 21, 27, 33, 39, 45, 51, 57, 63, 69, 75, 81, 87, 93, 99],
  [4, 10, 16, 22, 28, 34, 40, 46, 52, 58, 64, 70, 76, 82, 88, 94, 100],
  [5, 11, 17, 23, 29, 35, 41, 47, 53, 59, 65, 71, 77, 83, 89, 95, 101],
]

const huochairenMatrixData = [
  [41, 0, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72],
  [53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 73, 74, 75],
  [43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 76, 77, 78],
  [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 0, 0, 0, 0],
  [225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 0, 0, 82, 0],
  [224, 227, 226, 44, 0, 0, 0, 0, 0, 0, 230, 255, 101, 228, 80, 81, 79],
]

const lightMatrixDataCache = new Map<DefineDevice, Map<number, number>>() // 缓存数据

export const lightMatrix = (device: DefineDevice) => {
  if (lightMatrixDataCache.has(device)) {
    return lightMatrixDataCache.get(device)! // 如果缓存中有数据，直接返回
  }

  const keyMap = new Map<number, number>()
  let keyboardMatrix = Na87ProKeyboardMatrix
  if (device == VirtualNd63 || device == VirtualNd63_Cyan) {
    keyboardMatrix = Nd63KeyboardMatrix
  }
  if (device == VirtualMg75 || device == VirtualMg75Pro) {
    keyboardMatrix = MG75KeyboardMatrix
  }
  if (device == VirtualMG63 || device == VirtualRA68_1 || device == VirtualMG75V2C12) {
    keyboardMatrix = huochairenMatrixData
  }

  for (let row = 0; row < lightMatrixData.length; row++) {
    for (let col = 0; col < lightMatrixData[row].length; col++) {
      const matrixKey = lightMatrixData[row][col] // matrix data 的值
      const keyboardValue = keyboardMatrix[row][col] // 键盘矩阵的值
      keyMap.set(matrixKey, keyboardValue)
    }
  }
  lightMatrixDataCache.set(device, keyMap) // 缓存数据
  return keyMap
}
